import decode from 'jwt-decode';

function setToken(token) {
  // Retrieves the user token from local storage
  localStorage.setItem('id_token', token);
}

function getToken() {
  // Retrieves the user token from local storage
  return localStorage.getItem('id_token')
}

function setProfile(profile) {
  // Retrieves the user profile from local storage
  localStorage.setItem('profile', JSON.stringify(profile))
}

function getProfile(){
  // Retrieves the profile data from localStorage
  const profile = localStorage.getItem('profile')
  return profile ? JSON.parse(localStorage.profile) : {}
}

function getRoles(){

  return getProfile().roles;
}

function loggedIn() {

  const token = getToken()
  return !!token && !isTokenExpired(token)
}

function logout(){
  localStorage.removeItem('id_token');
  localStorage.removeItem('profile');
}

export function getTokenExpirationDate(token){
  const decoded = decode(token)
  if(!decoded.exp) {
    return null
  }

  const date = new Date(0) // The 0 here is the key, which sets the date to the epoch
  date.setUTCSeconds(decoded.exp)
  return date
}

export function isTokenExpired(token){
  const date = getTokenExpirationDate(token)
  if (date === null) {
    return false
  }
  return !(date.valueOf() > new Date().valueOf())
}

export {
  logout,
  loggedIn,
  setToken,
  getToken,
  setProfile,
  getProfile,
  getRoles
}



// WEBPACK FOOTER //
// ./src/utils/AuthHelper.js